export enum Locale {
  PT_BR = 'pt-BR',
  EN = 'en',
}
